/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FileOperation {
  FileOperationCreated = 'created',
  FileOperationRemoved = 'removed',
  FileOperationUpdated = 'updated',
}
